module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index"
  }, [(_vm.isDianDianHome) ? _c('div', {
    staticClass: "fi-mobile"
  }, [_c('fi-header-mobile', {
    attrs: {
      "is-mark": _vm.oMark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "banner-main"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("借点")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("想你所想,及你所急")])]), _vm._v(" "), _c('span', [_vm._v("点一点，最高20万额度，日利息低至0.025%起，借10000最低每天只需2元利息。 资质达标1秒审核，3秒放款。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/flat/mobile/mb-6.png")
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("点点商城")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("年轻人的in生活指南")])]), _vm._v(" "), _c('span', [_vm._v("点一点，汇集时尚潮物，甄选全网低价尖货。 众安保险保障账户安全，为购物保驾护航。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/flat/mobile/mb-1.png")
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("点点闪付")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("与中国银联深度合作")])]), _vm._v(" "), _c('span', [_vm._v("点一点，支持全国百万商户线上线下消费， 可享受支付立减专属优惠， 安全、省心、省钱。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/flat/mobile/mb-2.png")
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("生活缴费")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("足不出户，生活助手")])]), _vm._v(" "), _c('span', [_vm._v("点一点，所有水、电、煤等生活缴费， 在手机上即可完成。 生活已然艰辛，点点为您省心。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/flat/mobile/mb-3.png")
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("娱乐充值")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("游戏、视频、礼品卡")])]), _vm._v(" "), _c('span', [_vm._v("点一点，畅玩无限，享轻奢新主义， 为生活添色彩。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/flat/mobile/mb-4.png")
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("办信用卡")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("精选各大银行易下好卡")])]), _vm._v(" "), _c('span', [_vm._v("点一点，即刻在线完成申请， 额度大、颜值高、审批快、权益多, 让办卡不再困难。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/flat/mobile/mb-5.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination my-swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "download-btn",
    on: {
      "click": _vm.downloadMobile
    }
  }, [_vm._v("立即下载")]), _vm._v(" "), _c('div', {
    staticClass: "home-icon"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('fi-footer-mobile'), _vm._v(" "), _c('fi-mark', {
    attrs: {
      "is-mark": _vm.oMark
    }
  }), _vm._v(" "), (_vm.isJgWinMob) ? _c('div', {
    staticClass: "dd-jg-win-mob"
  }, [_c('div', {
    staticClass: "jg-main"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.isJgWinMob = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "jg-bg"
  }), _vm._v(" "), _vm._m(2)])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isBepoint) ? _c('div', [_c('iframe', {
    staticClass: "fdyx",
    attrs: {
      "src": "https://one.zhongan.com/fcp/fdyx/index.htm"
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jy-list"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg"
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adv-box"
  }, [_c('div', {
    staticClass: "adv-top hz-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "adv-main"
  }, [_c('div', {
    staticClass: "ys-main"
  }, [_c('ul', [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('a', {
    attrs: {
      "href": "#/pdxy"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01b7040a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/flatindexmobile.vue
// module id = 350
// module chunks = 1